import { z } from 'zod/v3';
import { errorMap } from '../../../common/utils';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from '../CloneAlgorithmsModal.translations.json';

const { addTranslations, t } = i18nNsFactory(
  'clone-algorithms-valid-form-data-schema',
);
addTranslations(translations);

export const CloneAlgorithmsValidFormDataSchema = z.object({
  dataObjectId: z.number(errorMap(() => t('fields.dataObject.required'))),
  versionId: z.number(errorMap(() => t('fields.version.required'))),
});
